import Cookies from '../utilities/Cookies';
import Component from '../site/Component';
import Analytics from './Analtyics';

/**
 * Component for Klaviyo event collection
 */
export default class KlaviyoHachette extends Component {
  /**
   * Start the component (called when Component is instantiated)
   */
	start() {
	this.cookie = new Cookies();

	  window.addEventListener('load', () => {
		if (`next` === this.cookie.getCookie('cookie__privacy_policy')) {
		  this.initializeKlaviyoSdk();
		  this.onClickHandlers();
		  this.onSignupLinkHanders();
		}
		this.privacyPolicyOptInOut();
	  });
	}

  /**
 * initialize Klaviyo SDK
 */
  initializeKlaviyoSdk() {
    const { klaviyo } = window;

    let href = '';
    try {
      const url = new URL(window.location.href, window.location.origin); // normalize
      href = url.toString();
    } catch (e) {
      console.warn("Invalid URL blocked:", href);
      href = '';
    }

    const id = {};

    if (this.isAuthorPage()) {
      const authorData = this.getAuthorData();
      klaviyo.push(['track', 'Author View', { author: authorData }]);
      Object.assign(id, { 'Last Author Viewed': authorData });
    }

    if (this.isGenerePage()) {
      const genreData = this.getGenreData();
      klaviyo.push(['track', 'Genre View', { genre: genreData }]);
      Object.assign(id, { 'Last Genre Viewed': genreData });
    }

    if (this.isProductPage() || this.isISBNPage()) {
      const productData = this.isProductPage() ? this.getProductData() : undefined;
      const isbnData = this.isISBNPage() ? this.getISBNData() : undefined;
      const genres = [];
      const series = [];
      const jsonEl = document.querySelector("#hachetteJsonLinkingData");
  	  const productDatajsonEl = JSON.parse(jsonEl.innerText);
	    const productImage = productDatajsonEl.image?.[0] || "";
	    const productImageURL = productImage.split("?")[0];
      const offer = Array.isArray(productDatajsonEl.offers) ? productDatajsonEl.offers[0] : productDatajsonEl.offers;
      const price = offer?.price || null;
      const priceCurrency = offer?.priceCurrency || "USD";

            // Method 1: Get genres 2-4 from the Genre section specifically
      const taxonomSection = document.querySelectorAll('.product-supplemental__taxonomies > .product-supplemental__taxonomies-genre');
      if (taxonomSection && taxonomSection.length) {
        const genreLinks = taxonomSection[0].querySelectorAll('.product-supplemental__taxonomies-list li a');
        Array.from(genreLinks).slice(1, 4).map(link => link.textContent.trim()).forEach(genre => genres.push(genre));
      }

      if (taxonomSection && taxonomSection.length > 1) {
        const seriesLinks = taxonomSection[1].querySelectorAll('.product-supplemental__taxonomies-list li a');
        Array.from(seriesLinks).slice(0, 3).map(link => link.textContent.trim()).forEach(s => {
          if (!series.includes(s)) {
            series.push(s);
          }
        });
      }

      if (productData) {
        Object.assign(id, { 'Last Product Viewed': productData });
      } 
      if (isbnData) {
        Object.assign(id, { 'Last ISBN Viewed': isbnData });
      }

      klaviyo.identify(id);
      klaviyo.push(['track', 'Product View', { 
        page_url: href,
        title: productData ?? '',
        image: productImageURL ?? '',
        isbn: isbnData ?? '',
        genre: genres ?? [],
        series: series.length > 0 ? series[0] : '',
        price: price,
		    priceCurrency: priceCurrency
      }]);
    }
  }


  /**
   * Get campaign params from URL
   * URL example: hachettebookgroup.com/contributor/author-name/?lens=example&utm_source=test1&utm_medium=test2&utm_campaign=test3&utm_content=test4&utm_term=test5#testanchor
   */
  getCampaignData(url) {
    var urlObj = new URL(url);
    return {
      name: urlObj.searchParams.get("utm_campaign"),
      source: urlObj.searchParams.get("utm_source"),
      medium: urlObj.searchParams.get("utm_medium"),
    };
  }

  /**
 * Privacy policy opt in and out
 */
  privacyPolicyOptInOut() {
    const optIn = document.querySelector('#privacyOptInOut #optIn');
    if (optIn) {
      optIn.addEventListener('click', () => {
        this.initializeKlaviyoSdk();
        this.onClickHandlers();
      });
    }
  }

  onSignupLinkHanders() {
    const { klaviyo } = window;

    document.querySelectorAll('a.site-header__newsletter-link')?.forEach(item => {
      item.addEventListener('click', function (event) {
        event.preventDefault();
        const href = item.href;

        // klaviyo.push(['track', 'Signup Link', { href: href }]);

        const newsletters = document.querySelectorAll('.newsletter-signup-content');
        if (newsletters.length) {
          newsletters[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          setTimeout(() => {
            try {
              const url = new URL(href, window.location.origin); // normalize
              // optional: restrict to same origin
              window.location.assign(url.toString());
            } catch (e) {
              console.warn("Invalid URL blocked:", href);
            }
          }, 50);
        }
      });
    });
  }  

  onClickHandlers() {
    const self = this; // Store reference to 'this' for use in event handlers
    const { klaviyo } = window;

    document.querySelectorAll('a.title-formats-prices__item')?.forEach(item => {
      item.addEventListener('click', function (event) {
        const format = this.querySelector('.title-format-item');
        event.preventDefault();
        const href = item.href;

        const formatName = self.getFormatName(format);
        if (formatName) {
          klaviyo.push(['track', 'Format Click', { format: formatName }]);
        }

        setTimeout(() => {
          try {
            const url = new URL(href, window.location.origin); // normalize
            // optional: restrict to same origin
            window.location.assign(url.toString());
          } catch (e) {
            console.warn("Invalid URL blocked:", href);
          }
        }, 200);
      });
    });

    document.querySelectorAll('a.title-buy-direct__button')?.forEach(item => {
      item.addEventListener('click', function (event) {
        event.preventDefault();
        const href = item.href;

        const retailerName = self.getRetailerName(this);
        klaviyo.push(['track', 'Retailer Click', { retailer: retailerName }]);

        setTimeout(() => {
          try {
            const url = new URL(href, window.location.origin); // normalize
            // optional: restrict to same origin
            window.location.assign(url.toString());
          } catch (e) {
            console.warn("Invalid URL blocked:", href);
          }
        }, 200);
      });
    });

   document.addEventListener('click', function (event) {
	  console.log('[Klaviyo] Click detected:', event.target);

	  const btn = event.target.closest('.title-add-to-cart__button');
	  if (!btn) {
		console.log('[Klaviyo] Not an add-to-cart click');
		return;
	  }

	  console.log('[Klaviyo] Add-to-cart button clicked ✅', btn);

	  const jsonEl = document.querySelector("#hachetteJsonLinkingData");
	  if (!jsonEl) {
		console.warn('[Klaviyo] #hachetteJsonLinkingData not found ❌');
		return;
	  }

	  let data;
	  try {
		data = JSON.parse(jsonEl.innerText);
		console.log('[Klaviyo] JSON parsed:', data);
	  } catch (e) {
		console.error('[Klaviyo] Failed to parse JSON ❌', e);
		return;
	  }

	  const productData = self.getProductData();
	  const authorData = self.getTitleAuthorData();
	  const isbnData = self.getISBNData();

	  console.log('[Klaviyo] Product data:', productData);
	  console.log('[Klaviyo] Author data:', authorData);
	  console.log('[Klaviyo] ISBN data:', isbnData);

	  const genres = Array.isArray(data.genre) ? data.genre.join(", ") : "";
	  const publisher = data.publisher?.name || "";

	  const offer = Array.isArray(data.offers) ? data.offers[0] : data.offers;
	  const price = offer?.price || null;
	  const priceCurrency = offer?.priceCurrency || "USD";

	  console.log('[Klaviyo] Price:', price, priceCurrency);
	  console.log('[Klaviyo] Genres:', genres);
	  console.log('[Klaviyo] Publisher:', publisher);

	  if (!window.klaviyo) {
		console.error('[Klaviyo] window.klaviyo is not defined ❌');
		return;
	  }

	  console.log('[Klaviyo] Sending event to Klaviyo... 🚀');

	  klaviyo.push([
		'track',
		'Add To Cart Clicked',
		{
		  title: productData,
		  author: authorData,
		  isbn: isbnData,
		  genres: genres,
		  publisher: publisher,
		  price: price,
		  priceCurrency: priceCurrency
		}
	  ]);

	  console.log('[Klaviyo] Event pushed successfully ✅');
	});



    document.querySelectorAll('ai-truncate[truncated=true] button')?.forEach(item => {
      item.addEventListener('click', function (event) {
        const productData = self.getProductData();
        const authorData = self.getTitleAuthorData();
        const isbnData = self.getISBNData();
        const jsonEl = document.querySelector("#hachetteJsonLinkingData");
        const productDatajsonEl = JSON.parse(jsonEl.innerText);
        const productImage = productDatajsonEl.image?.[0] || "";
        const productImageURL = productImage.split("?")[0];
        const offer = Array.isArray(productDatajsonEl.offers) ? productDatajsonEl.offers[0] : productDatajsonEl.offers;
        const price = offer?.price || null;
        const priceCurrency = offer?.priceCurrency || "USD";
        klaviyo.push(['track', 'Continue Reading Clicked', { title: productData, image: productImageURL ?? '', author: authorData, isbn: isbnData, price: price, priceCurrency: priceCurrency }]);
      });
    });

    document.querySelectorAll('audio')?.forEach(item => {
      item.addEventListener("play", function (event) {
        const productData = self.getProductData();
        const authorData = self.getTitleAuthorData();
        const isbnData = self.getISBNData();
        klaviyo.push(['track', 'Audio Excerpt Clicked', { title: productData, author: authorData, isbn: isbnData }]);
      });
    });
  }

  getFormatName(formatItem) {
    // Create a copy of the element so we don't modify the original
    const clone = formatItem.cloneNode(true);
    // Remove all price span elements from the copy
    clone.querySelectorAll('.title-format-item__price').forEach(price => {
      price.remove();
    });

    // Return the cleaned text content
    return clone.textContent.trim();
  }
  getRetailerName(retailerItem) {
    // Create a copy of the element so we don't modify the original
    const clone = retailerItem.cloneNode(true);
    // Return the cleaned text content
    return clone.textContent.trim();
  }

  isAuthorPage() {
    return document.querySelector('h1.meet-the-author__title') && document.querySelector('body.single-contributor')
  }

  getAuthorData() {
    return document.querySelector('h1.meet-the-author__title')?.innerText;
  }
  getTitleAuthorData() {
    const authorLink = document.querySelector('.product-details__contributors .product-details__contributor-link');
    return authorLink ? authorLink.textContent.trim() : null;
  }

  isGenerePage() {
    return document.querySelector('h1.genre-details_title')
  }

  getGenreData() {
    return document.querySelector('h1.genre-details_title')?.innerText;
  }

  isProductPage() {
    return document.querySelector('h1.product-details__title')
  }

  getProductData() {
    return document.querySelector('h1.product-details__title')?.innerText;
  }

  isISBNPage() {
    const isbn13Element = document.evaluate(
      "//div[contains(@class, 'product-supplemental__details__group')][.//dt[contains(@class, 'product-supplemental__details__term') and normalize-space(text())='ISBN-13']]//dd[contains(@class, 'product-supplemental__details__def')]",
      document,
      null,
      XPathResult.FIRST_ORDERED_NODE_TYPE,
      null
    ).singleNodeValue;

    return isbn13Element !== null;
  }

  getISBNData() {
    const isbn13Element = document.evaluate(
      "//div[contains(@class, 'product-supplemental__details__group')][.//dt[contains(@class, 'product-supplemental__details__term') and normalize-space(text())='ISBN-13']]//dd[contains(@class, 'product-supplemental__details__def')]",
      document,
      null,
      XPathResult.FIRST_ORDERED_NODE_TYPE,
      null
    ).singleNodeValue;

    const isbn13Value = isbn13Element ? isbn13Element.textContent.trim() : null;
    return isbn13Value;
  }
}
